import { v4 as uuidv4 } from "uuid";
export class EntryAddModel {
    constructor() {
        this.id = uuidv4();
        this.referenceNumber = "";
        this.description = "";
        this.referenceLink = "";
        this.whyItMatters = "";
        this.amendments = "";
        this.entryCategories = [];
        this.entryTags = [];
        this.stateId = "";
        this.typeId = "";
        this.dateOpenedAsString = "";
    }
}
export default class EntryAdd extends EntryAddModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
